import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { RestaurantProfile } from '../../../models/List.Restaurant';
import { RestaurantService } from '../../../services/Restaurant.service';
import { RestaurantFormDialogComponent } from '../../restaurant-form-dialog/restaurant-form-dialog.component';

@Component({
  selector: 'app-head-details',
  templateUrl: './head-details.component.html'
})
export class HeadDetailsComponent implements OnInit {
  @Input() restaurantProfile?: RestaurantProfile;

  dataLoading = false;
  lang = localStorage.getItem('language') || 'en';


  @Output() isReady = new EventEmitter();
  // Restaurant ID
  restaurantId?: any;
  constructor(private route: ActivatedRoute,
    public translate: TranslateService,
    private router: Router,
    private service: RestaurantService,
    public dialog: MatDialog) {
    this.route.params.subscribe(params => {
      this.restaurantId = params['id'];
    });

  }

  ngOnInit(): void { }

  DeleteRestaurant() {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        this.service.DeleteRestaurant(this.restaurantId).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.deletededsuccessfuly'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.router.navigate(['/admin/restaurants'])
            }
          },
          (error: any) => {
            this.dataLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          });
      }
    });
  }


  openForm() {
    const dialogRef = this.dialog.open(RestaurantFormDialogComponent, {
      width: '50rem',
      data: {
        record: this.restaurantProfile
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.refreshDetails.next(true);
      }
    });
  }

  print(): void {
    const basicUrl = location.origin;
    let style = basicUrl + '/assets/scss/rest-Qrcode.print.css';
    const mywindow: any = window.open('', 'PRINT', 'height=1000,width=600');
    mywindow.document.write('<html dir="ltr" lang="en"><head>\
      <base href="/">\
      <meta charset="UTF-8">\
      <meta name="viewport" content="width=device-width, initial-scale=1.0">\
      <meta http-equiv="X-UA-Compatible" content="ie=edge">\
      <link rel="stylesheet" type="text/css" href="' + style + '">\
      <title>' + document.title + '</title>');
    mywindow.document.write('</head><body>');
    mywindow.document.write(document.getElementById("qrCode-print")?.innerHTML);
    mywindow.document.write('</body></html>');
    this.isReady.emit(true)

    mywindow.document.close();
    mywindow.focus();

    mywindow.onload = () => {
      mywindow.print();
    };
  }
}
